window.addEventListener("load", () => {
  console.log("Nosto Page Script Loaded");
  
  /* -------------------------------
   * Helpers
   * ----------------------------- */
  function updateColorVariantCount(el) {
    if (el.dataset.countUpdated) return;
    el.dataset.countUpdated = "true";
    const values = (el.textContent || "").split("|");
    if (values.length > 1) {
      const tpl =
        (window.theme &&
          window.theme.strings &&
          window.theme.strings.colorsMore) ||
        "Colors +[count]";
      el.textContent = tpl.replace("[count]", String(values.length - 1));
      el.style.opacity = 1;
    } else {
      el.textContent = "";
    }
  }

  function wrapDivsWithAnchor() {
    document.querySelectorAll(".nosto-image-container").forEach(container => {
      if (container.closest("a")) return;
      const url = container.getAttribute("product-url");
      if (url) {
        const a = document.createElement("a");
        a.href = url;
        container.parentNode.insertBefore(a, container);
        a.appendChild(container);
      }
    });
  }

  /* -------------------------------
   * Flickity
   * ----------------------------- */
  function initSlider(slider, opts = {}) {
    if (!slider || slider.closest("[data-cart-upsell]") || Flickity.data(slider)) return;

    function tryInit(attempts = 0) {
      const items = slider.querySelectorAll(".nosto-list-item");
      const hasItems = items.length > 0;
      const hasHeight = slider.offsetHeight > 0 || (items[0] && items[0].offsetHeight > 0);

      if (hasItems && hasHeight) {
        const tallest = Math.max(...Array.from(items).map(i => i.offsetHeight));
        slider.style.minHeight = (tallest / 2) + "px";

        const flkty = new Flickity(slider, Object.assign({
          cellAlign: "left",
          contain: true,
          prevNextButtons: true,
          pageDots: false
        }, opts));

        requestAnimationFrame(() => {
          flkty.resize();
          flkty.reposition();
          slider.style.visibility = "visible";

          setTimeout(() => {
            flkty.resize();
            flkty.reposition();
            slider.style.visibility = "visible";
          }, 50);
        });

        console.log("✅ Init slider:", slider.className);
      } else if (attempts < 50) {
        setTimeout(() => tryInit(attempts + 1), 100);
      } else {
        console.warn("⚠️ Slider never became visible:", slider.className);
      }
    }

    tryInit();
  }

  /* -------------------------------
   * Wishlist
   * ----------------------------- */
  function initWishlistButtons(scope = document) {
    if (window.theme && typeof window.theme.bindWishlistButtons === "function") {
      window.theme.bindWishlistButtons(scope, ".wishlist");
      return;
    }
    scope.querySelectorAll(".wishlist").forEach(btn => {
      const { empi, epi } = btn.dataset;
      if (window.myWishList) {
        const match = window.myWishList.find(i => i.empi == empi || i.epi == epi);
        if (match) btn.classList.add("is-saved");
      }
    });
  }

  /* -------------------------------
   * Add to Cart
   * ----------------------------- */


  /* -------------------------------
   * Initialize All Sliders on Page
   * ----------------------------- */
  function initAllSliders() {
    document.querySelectorAll(".nosto-list").forEach(slider => {
      if (slider.closest("[data-cart-upsell]")) return;
      initSlider(slider);
      slider.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
      initWishlistButtons(slider);
      // initCartATC(slider);
    });
  }

  /* -------------------------------
   * Observer for Dynamically Added Content
   * ----------------------------- */
  const nostoObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches(".nosto-list")) {
          if (node.closest("[data-cart-upsell]")) return;
          initSlider(node);
          node.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
          initWishlistButtons(node);
          initCartATC(node);
        } else {
          node.querySelectorAll(".nosto-list").forEach(slider => {
            if (slider.closest("[data-cart-upsell]")) return;
            initSlider(slider);
            slider.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
            initWishlistButtons(slider);
            // initCartATC(slider);
          });
        }
      });
    });
  });
  nostoObserver.observe(document.body, { childList: true, subtree: true });

  /* -------------------------------
   * Init on Load
   * ----------------------------- */
  wrapDivsWithAnchor();
  initAllSliders();
  initWishlistButtons();
});